/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  function watchNavigationScroll() {
    if($(window).scrollTop() > 0) {
      $('body').addClass('scrolled');
    }
    else {
      $('body').removeClass('scrolled');
    }
  }

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        watchNavigationScroll();
        
        $(window).on('load resize scroll', function() {
          watchNavigationScroll();
        });

        $('#navigation').on('show.bs.collapse', function () {
          $('body').addClass('nav-on');
        });

        $('#navigation').on('hide.bs.collapse', function () {
          $('body').removeClass('nav-on');
        });

        var wow = new WOW(
          {
            boxClass:     'wow',      // animated element css class (default is wow)
            animateClass: 'animated', // animation css class (default is animated)
            offset:       70,          // distance to the element when triggering the animation (default is 0)
            mobile:       true,       // trigger animations on mobile devices (default is true)
            live:         true,       // act on asynchronously loaded content (default is true)
            callback:     function(box) {
              box.addEventListener('animationend', function( event ) {
                $(this).addClass('animation-finished');
              });
            },
            scrollContainer: null // optional scroll container selector, otherwise use window
          }
        );
        wow.init();

        $('.logos-carousel').slick({
          autoplay: true,
          autoplaySpeed: 3000,
          speed: 1000,
          dots: false,
          arrows: true,
          centerMode: true,
          centerPadding: '0px',
          variableWidth: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          pauseOnFocus: false,
          pauseOnHover: false,
          prevArrow: '<a href="#" class="slick-arrow slick-prev"><span class="fa fa-angle-left"></span></a>',
          nextArrow: '<a href="#" class="slick-arrow slick-next"><span class="fa fa-angle-right"></span></a>'
        });

        if( $('.images-carousel').length ) {
          $('.images-carousel').each(function(i) {
            var t = $(this);
            
            t.closest('section').find('.dots').attr('data-dots-control', i);

            t.slick({
              fade: true,
              autoplay: true,
              autoplaySpeed: 4000,
              dots: true,
              appendDots: '.dots[data-dots-control="'+i+'"]',
              arrows: false
            });
          });
        }

        $('.testimonials-carousel').slick({
          autoplay: true,
          autoplaySpeed: 5000,
          dots: true,
          arrows: false
        });

        $(document).on('click', 'a[href^="#"]', function(e) {
          var target = $( $(this).attr('href') );

          if(target.length) {
            e.preventDefault();

            $('html, body').stop().animate({
              scrollTop: target.offset().top - 70
            }, 'slow');
          }
        });
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
